import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import arrowForwardImg from "../images/arrow-forward.svg"
import lineImg from "../images/lineLast.png"
import lineImg1 from "../images/lineLast1.png"
import Rating from "react-rating"
import { secUser, guidance, database } from '../firebase'
import $ from 'jquery';

export default class AssesmentApply3 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      skillData: [],
      rateValue: 0,
      newSkillFlag: false,
      skillDataNew: []
    }
    this.changeRating = this.changeRating.bind(this)
  }
  changeRating = (event) => {
    //console.log("jjjjj",event);
    this.setState({
      rateValue: event
    })

  }
  testimonialPopup(y) {
    this.state.ratingVal = 0;
    $("#hidRating").val(y)
    $("body").addClass("modal-open");
    $("#skillRatePopup").addClass("show");
    $(".modal").show();
    $('.modal-backdrop').add();
    $("#testimonialPopup video").show();
    $('body').append('<div class="modal-backdrop fade show"></div>');
  }
  closePopup() {
    $("body").removeClass("modal-open");
    $(".modal").removeClass("show");
    $(".modal").hide();
    $('.modal-backdrop').remove();
  }
  confirmRating(ratingVal) {
    var hidRating = $("#hidRating").val()
    $("#divRating" + hidRating).text(ratingVal)
    this.closePopup()
  }
  updateData() {
    let skillUserRating = []
    for (let i = 0; i < $("#hidNewSkill").val(); i++) {
      let rating
      let skillName = ""
      let skillChecked = "false"
      if ($("#divRating" + i).text() == "+") {
        rating = 0
      }
      else {
        rating = $("#divRating" + i).text()
      }
      if ($("#divRatingName" + i).text()) {
        skillName = $("#divRatingName" + i).text()
      }
      else {
        skillName = $("#divRatingName" + i).val()
      }
      if ($("#chk" + i).prop('checked')) {
        skillChecked = "true"
      }
      skillUserRating[i] = {
        skillName: skillName,
        skillRating: rating,
        skillChecked: skillChecked
      }
    }
    let progressInfo = parseInt(localStorage.getItem("progressInfo"));
    if (skillUserRating.length > 0) { progressInfo = progressInfo + 20 }
    localStorage.setItem("progressInfo", progressInfo)

    const dataSet = {
      skillUserRating: skillUserRating.length > 0 ? skillUserRating : "",
      progressInfo: progressInfo
    }
    database.ref(`Guidance/${this.props.match.params.key}`).update(dataSet).then(() => {
      window.location.href = "/user-dashboard"

    }).catch(() => {
      alert("Somthing went wrong")
    })
    //window.location.href = "/assesment/apply-5"
  }
  async componentDidMount() {
    let skillList = [];
    let userExpertise = localStorage.getItem("userExpertise");
    let userGoalExpertise = localStorage.getItem("userGoalExpertise");
    let expertise = userGoalExpertise ? userGoalExpertise : userExpertise
    await database.ref("skills").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active' && ChildSnapshot.val().expertise == expertise) {
          skillList.push({
            skill: ChildSnapshot.val().skill
          });
        }
      });
      $("#hidNewSkill").val(skillList.length)
    });
    this.setState({
      skillData: skillList
    });
    this.renderList()
  }
  renderList() {
    let data = JSON.parse(localStorage.getItem("guidanceArray"))
    console.log(data);
    data.skillUserRating.forEach(function (d, i) {
      $("#divRating" + i).text(d.skillRating)
      if (d.skillChecked === "true") {
        $("#chk" + i).prop('checked', true)
      }
    })
  }
  // addSkill() {

  //   let newSkillCount
  //   if($("#hidNewSkill").val()){
  //     newSkillCount = parseInt($("#hidNewSkill").val())+1
  //     $("#hidNewSkill").val(newSkillCount)
  //   }
  //   else{
  //     newSkillCount = 1
  //     $("#hidNewSkill").val(newSkillCount)
  //   }
  //   $("#addSkillWrapper").append('<tr><td><i class="fa fa-star text-muted"></i></td><td><div class="form-group m-0 p-0"><input type="text" id="divRatingName'+newSkillCount+'" class="form-control"  /></div></td><td><div id ="divRating'+newSkillCount+'" class="self-rate-num self-rate-active" onClick=ratingPopup('+newSkillCount+')>+</div></td><td class="text-center"><i class="fa fa-close text-muted"></i></td></tr>')
  // }

  addSkillTemplate() {
    let newSkillCount
    if ($("#hidNewSkill").val()) {
      newSkillCount = parseInt($("#hidNewSkill").val()) + 1
    }
    else {
      newSkillCount = 1
    }
    $("#hidNewSkill").val(newSkillCount)
    var skillData = this.state.skillDataNew;
    //alert("123..."+$("#divRatingName"+newSkillCount).val())
    skillData.push({ skill: '' })
    this.setState({ skillDataNew: skillData });
  }

  render() {

    return (

      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content" style={{ background: "#f4f6f9" }}>
          <div className="container p-0 pt-5">
            <div className='row'>
              <div className='col-lg-10 m-auto p-0'>
                <form className='form-main-wrapper form-main-wrapper-100'>
                  <div className='form-group progress-det'>
                    <div className="form-group subhead">Select the skills you want to develop and rate them accordingly</div>
                    {/* <span className='progress-content'>Step 4/5 : Skill Rating</span>
                      <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width:"80%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                      </div> */}
                  </div>
                  <hr></hr>
                  <input type="hidden" id="hidRating"></input>
                  <input type="hidden" id="hidNewSkill"></input>
                  <div className='form-group subhead text-left'>
                    {/* See Suggested Skill Rating */}
                    <span className="btn btn-theme btn-sm my-2" onClick={() => this.addSkillTemplate()} style={{ float: 'right' }}>
                      Add New Skill
                    </span>
                  </div>
                  <div className='table table-main form-group'>
                    <table className="table" >
                      <thead>
                        <tr>
                          <th width="40">
                            <i className='fa fa-question-circle'></i>
                          </th>
                          <th width="300">Skill</th>
                          <th className='text-center'>Self Rating</th>
                          {/* <th>Source</th> */}
                          <th className='text-center'>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.skillData.map((x, y) =>
                          <tr>
                            <td>
                              <input type={'checkbox'} id={'chk' + y}></input>
                            </td>
                            <td>
                              <i className='fa fa-star text-muted'></i>
                            </td>


                            <td><div id={"divRatingName" + y}>{x.skill}</div></td>


                            {/* <td><input type="text" id={"divRatingName"+y} class="form-control" value={x.skill} /></td> */}
                            <td>
                              <div id={"divRating" + y} className='self-rate-num self-rate-active' onClick={() => this.testimonialPopup(y)}>+</div>
                            </td>
                            {/* <td>Source</td> */}
                            <td className='text-center'>
                              <i className='fa fa-close text-muted'></i>
                            </td>
                          </tr>
                        )
                        }
                      </tbody>

                      <tbody>
                        {this.state.skillDataNew.map((x, y) =>
                          <tr>
                            <td>
                              <i className='fa fa-star text-muted'></i>
                            </td>

                            <div class="form-group m-0 p-0"><input type="text" id={"divRatingName" + parseInt(this.state.skillData.length + y)} class="form-control" /></div>

                            <td>
                              <div id={"divRating" + parseInt(this.state.skillData.length + y)} className='self-rate-num self-rate-active' onClick={() => this.testimonialPopup(parseInt(this.state.skillData.length + y))}>+</div>
                            </td>
                            {/* <td>Source</td> */}
                            <td className='text-center'>
                              <i className='fa fa-close text-muted'></i>
                            </td>
                          </tr>
                        )
                        }
                      </tbody>
                      <tbody id="addSkillWrapper">
                        {/* <tr>
                          <td>
                            <i className='fa fa-star text-muted'></i>
                          </td>
                          <td>
                            <div id={"divRatingName"} className="form-group m-0">
                              <input type="text" className="form-control"  />
                            </div>
                          </td>
                          <td>
                            <div id={"divRating"} className='self-rate-num self-rate-active' onClick={() => this.testimonialPopup()}>+</div>
                          </td>
                          <td className='text-center'>
                            <i className='fa fa-close text-muted'></i>
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>

                  <div className="form-group mt-4">
                    <a className="btn btn-gray w-100" onClick={() => this.updateData()}>
                      Next <img src={arrowForwardImg} className="arrow-filter"></img>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

        <div className="modal fade skill-rate-popup" id="skillRatePopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
          <div className="modal-dialog" role="document" style={{ maxWidth: '706px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">Rate your expertise in "Product Marketing"</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.closePopup()}>
                  <span aria-hidden="true" style={{ marginLeft: '244px' }}>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Rating
                  onChange={this.changeRating}
                  className='skillRate'
                  stop={10}
                  emptySymbol={<img src={lineImg} className="skillRateIcon" />}
                  fullSymbol={<img src={lineImg1} className="skillRateIcon" />}
                />
                {/* 
                  <div className='tracking'>
                    <span className='tracking-span tracking-span1 tracking-span-active'>
                      <p>1</p>
                    </span>
                    <span className='tracking-span tracking-span2 tracking-span-active'>
                      <p>2</p>
                    </span>
                    <span className='tracking-span tracking-span3'>
                      <p>3</p>
                    </span>
                    <span className='tracking-span tracking-span4'>
                      <p>4</p>
                    </span>
                    <span className='tracking-span tracking-span5'>
                      <p>5</p>
                    </span>
                    <span className='tracking-span tracking-span6'>
                      <p>6</p>
                    </span>
                    <span className='tracking-span tracking-span7'>
                      <p>7</p>
                    </span>
                    <span className='tracking-span tracking-span8'>
                      <p>8</p>
                    </span>
                  </div> */}
                <div className='tracking-btm row'>
                  <div className='col-6'>BEGINNER</div>
                  <div className='col-6 text-right'>EXPERT</div>
                </div>
                <div className='skill-rate-det'>
                  <div className='self-rate-num my-2'>{this.state.rateValue}</div>
                  1.You can complete limited tasks requiring basic skills with continuous guidance.<br></br>
                  2.You can complete routine technical tasks requiring basic skills with general supervision or guidance.<br></br>
                  3.You can process less structured technical tasks with well-defined tasks with occasional guidance.<br></br>
                  4.You can complete specialised tasks by using knowledge from theoretical and practical experiences. May or may not have overall supervision or guidance for these tasks.<br></br>
                  5.You can complete specialised tasks by using knowledge from theoretical and practical experiences. May or may not have overall supervision or guidance for these tasks. <br></br>
                  6.You can complete broad, complex tasks by using knowledge from theoretical and practical experiences without any supervision or guidance.<br></br>
                  7.You can complete broad, complex tasks by using knowledge from theoretical and practical experiences without any supervision or guidance.<br></br>
                  8.You can complete complex tasks in several subspecialties of the skill. <br></br>
                  9.You can complete new and complex tasks, including choosing the best process for particular situations.<br></br>
                  10.You can develop new solutions or research using a wide range of scientific and creative strategies.<br></br>
                </div>
              </div>
              <div className="modal-footer" style={{ justifyContent: "space-between" }}>
                <button type="button" className="btn btn-theme bg-dark" data-dismiss="modal" onClick={() => this.closePopup()}>Close</button>
                <button type="button" className="btn btn-theme" onClick={() => this.confirmRating(this.state.rateValue)}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply4.jsx